import {
  Component,
  OnInit,
  OnDestroy,
  Input,
  ChangeDetectorRef,
  ChangeDetectionStrategy,
} from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { RenderedService } from '../../rendered.service';
import { BaseScaffoldComponent } from '../base-scaffold/base-scaffold.component';

@Component({
    selector: 'scaffold-anchor',
    templateUrl: './anchor.component.html',
    styleUrls: ['../../rendered.component.scss', './anchor.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class AnchorComponent
  extends BaseScaffoldComponent
  implements OnInit, OnDestroy
{
  public destroy$: Subject<boolean> = new Subject<boolean>();

  constructor(
    public cdr: ChangeDetectorRef,
    public renderedService: RenderedService
  ) {
    super(cdr, renderedService);
  }

  ngOnInit() {
    this.renderedService
      .listenForUpdates()
      .pipe(takeUntil(this.destroy$))
      .subscribe(trigger => {
        this.cdr.detectChanges();
      });
  }

  ngOnDestroy() {
    this.destroy$.next(true);
    this.destroy$.unsubscribe();
  }

  toURL(url) {
    if (url) {
      if (url.match(/^https*:\/\//)) {
        return url;
      } else {
        return 'https://' + url;
      }
    }

    return null;
  }
}
